import { gql } from '@apollo/client';

const RESOURCE_FRAGMENT = gql`
  fragment BaseResource on Resource {
    id
    title
    thumbnail
    description
    data
    characters {
      id
      character
      characterCase
      characterType
    }
    type {
      id
      type
      title
      icon
    }
    asset {
      id
      type
      src
      vtt
      captions
      narrationSrc
      narrationVtt
      narrationCaptions
      description
    }
    url
    tags {
      id
      tag
      value
    }
  }
`;

export default RESOURCE_FRAGMENT;
